import { render, staticRenderFns } from "./GoodsPromotionTablePane.vue?vue&type=template&id=0be70397&scoped=true"
import script from "./GoodsPromotionTablePane.vue?vue&type=script&lang=js"
export * from "./GoodsPromotionTablePane.vue?vue&type=script&lang=js"
import style0 from "./GoodsPromotionTablePane.vue?vue&type=style&index=0&id=0be70397&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be70397",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0be70397')) {
      api.createRecord('0be70397', component.options)
    } else {
      api.reload('0be70397', component.options)
    }
    module.hot.accept("./GoodsPromotionTablePane.vue?vue&type=template&id=0be70397&scoped=true", function () {
      api.rerender('0be70397', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/goods_promotion/GoodsPromotionTablePane.vue"
export default component.exports